import React, { useState } from 'react';
import { userServices } from '../../APIServices/userServices';
import { useToast } from '../../hooks/useToast';

function ChangePassword() {
  const toast = useToast();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [buttonLoader, setButtonLoader] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!currentPassword || !newPassword || !confirmPassword) {
      toast('Please complete all password fields', 'warn');
      return;
    }

    if (newPassword.length < 8) {
      toast('New password must be at least 8 characters', 'warn');
      return;
    }

    if (newPassword !== confirmPassword) {
      toast('New password and confirmation do not match', 'warn');
      return;
    }

    setButtonLoader(true);

    try {
      await userServices.changePassword({
        currentPassword,
        newPassword,
        confirmPassword,
      });
    } catch (error) {
      toast('Unable to update password. Please try again.', 'warn');
      setButtonLoader(false);
    }
  };

  return (
    <div>
      <div className="page-header">
        <div>
          <div className="page-eyebrow">Manage Password</div>

          <h1 className="page-title">Change Password</h1>

          <p className="page-sub">
            Update your account password to keep your account secure. Choose a strong password
            that is unique and not used for any other account to help protect your personal
            information and prevent unauthorized access.
          </p>
        </div>
      </div>

      <div className="flex between center mb-3">
        <div className="section-label">Change Password</div>
      </div>
      <div className="card" style={{ padding: 25 }}>
        <form onSubmit={handleSubmit}>
          <div className="field">
            <label className="field-label">
              Current Password <span className="req">*</span>
            </label>
            <input
              type="password"
              className="inp"
              placeholder="Enter current password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              disabled={buttonLoader}
            />
          </div>

          <div className="field">
            <label className="field-label">
              New Password <span className="req">*</span>
            </label>
            <input
              type="password"
              className="inp"
              placeholder="Enter new password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              disabled={buttonLoader}
            />
          </div>

          <div className="field">
            <label className="field-label">
              Confirm New Password <span className="req">*</span>
            </label>
            <input
              type="password"
              className="inp"
              placeholder="Re-enter new password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              disabled={buttonLoader}
            />
          </div>

          <div className="flex between center" style={{ gap: 12, marginTop: 20 }}>
            <button
              type="submit"
              className="btn btn-primary d-flex align-items-center justify-content-center gap-2"
              disabled={buttonLoader}
            >
              {buttonLoader ? 'Updating...' : 'Update Password'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ChangePassword;